<template>
    <div id="app">
        <menus></menus>
    </div>
</template>

<script>
    import menus from './components/home.vue'

    export default {
        name: 'app',
        data() {
            return {}
        },
        components: {
            menus
        },
        ready() {

        },
        beforeDestroy() {

        },
        methods: {},
        created() {
            //在页面加载时读取sessionStorage里的状态信息
            if (sessionStorage.getItem("store")) {
                this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
            }

            //在页面刷新时将vuex里的信息保存到sessionStorage里
            window.addEventListener("beforeunload", () => {
                sessionStorage.setItem("store", JSON.stringify(this.$store.state))
            })
        }
    }
</script>

<style>
    body {
        margin: 0 !important;
        padding: 0 !important;
    }

    #app {
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: left;
        color: #2c3e50;
    }

    div {
        background-image: url("https://agent-repair-prompt.sankuai.com/api-wm/image/visible?r=240&g=240&b=240&deg=-20&type=2");
        background-size: auto;
    }

    .notify-warning {
      left: 50%;
      transform: translateX(-50%);
      transition: opacity 0.3s, transform 0.3s, top 0.4s, bottom 0.3s;
    }
</style>



// WEBPACK FOOTER //
// app.vue?5d747a72